module.exports = __webpack_public_path__ + "static/media/prescolar-kids.da3cb308.png";